module.exports = __webpack_public_path__ + "5806a2561d22daf91f217fd8d1b68093.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/_element-ui@2.15.9@element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 813
// module chunks = 9